import { useContext, useMemo } from 'react';

import { Divider, LayoutCard, Skeleton, Stack } from '@cast/design-system';
import {
  DiffValues,
  SavingsSummary,
  WorkloadDetailsContext,
  normalizeWorkloadsSavings,
} from '@cast/split-me/features/cluster/workload-optimization';

const emptySavings: ReturnType<typeof normalizeWorkloadsSavings> = {
  estimatedMonthlySavings: undefined,
  estimatedMonthlySavingsPercentage: undefined,
  currentMonthlySavings: undefined,
  currentMonthlySavingsPercentage: undefined,
  currentMonthlyCost: undefined,
  currentRecommendedMonthlyCost: undefined,
};

export const InventoryWorkloadSavingsDifferenceCard = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  const savings = useMemo(() => {
    if (!workload?.costsPerHour) {
      return emptySavings;
    }
    return normalizeWorkloadsSavings(workload.costsPerHour);
  }, [workload]);

  if (!workload) {
    return (
      <LayoutCard testId="inventory-workload-savings-difference-card">
        <Stack
          display="grid"
          gridTemplateColumns="1fr 1fr"
          gap={24}
          alignItems="stretch"
        >
          <Skeleton height={96} width="100%" />
          <Skeleton height={96} width="100%" />
        </Stack>
      </LayoutCard>
    );
  }

  return (
    <LayoutCard testId="inventory-workload-savings-difference-card">
      <Stack
        display="grid"
        gridTemplateColumns="1fr auto 1fr"
        gap={24}
        alignItems="stretch"
      >
        <SavingsSummary savings={savings} />
        <Divider orientation="vertical" flexItem />
        <DiffValues cpu={workload.cpu} memory={workload.memory} />
      </Stack>
    </LayoutCard>
  );
};
